export default __webpack_public_path__ + "static/media/PotProPot.8637976d.png";